import { render, staticRenderFns } from "./EditDivision.vue?vue&type=template&id=736a4f6b"
import script from "./EditDivision.vue?vue&type=script&lang=js"
export * from "./EditDivision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EditDivision.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('736a4f6b')) {
      api.createRecord('736a4f6b', component.options)
    } else {
      api.reload('736a4f6b', component.options)
    }
    module.hot.accept("./EditDivision.vue?vue&type=template&id=736a4f6b", function () {
      api.rerender('736a4f6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/EditDivision.vue"
export default component.exports